import {FormItem as $FormItem, FormItemProps} from 'formik-antd';
import React from 'react';

export const FormItem: React.FC<FormItemProps> = props => {
  return <$FormItem {...props} htmlFor={props.name} />;
};
